<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-08 11:17:32
 * @LastEditors: lwq
 * @LastEditTime: 2020-07-13 11:10:49
-->
<template>
  <v-row
    @click="showDetail"
    class="d-flex justify-center align-center labelTranslate"
  >
    <v-col cols="12" sm="2" class="pl-12">{{ obj.client_type_label }}</v-col>
    <v-col cols="12" sm="2" offset-sm="2">{{ obj.version_code }}</v-col>
    <v-col cols="12" sm="3" offset-sm="1">
      <mrc_ess_chip
        v-for="item in obj.language_code ? obj.language_code.split(',') : []"
        :key="item"
        >{{ item }}</mrc_ess_chip
      >
    </v-col>
    <v-col cols="12" sm="1" offset-sm="1">
      <menu-list :list="list" @handleClick="handleClick">
        <template v-slot:showAction>
          <v-icon>mdi-dots-vertical</v-icon>
        </template>
      </menu-list>
    </v-col>
  </v-row>
</template>

<script>
export default {
  components: {},
  props: {
    obj: {
      type: Object,
    },
  },
  data() {
    return {
      list: [{ name: this.$t('label_Edit') }],
    }
  },
  computed: {},
  created() {},
  watch: {},
  mounted() {},

  methods: {
    handleClick() {
      console.log('handleClick')
    },
    showDetail() {
      console.log('showDetail')
    },
  },
}
</script>

<style scoped>
.labelTranslate {
  border-top: 1px solid #ececec;
  height: 65px;
  font-size: 16px;
}
</style>
